import React from "react";
import Typewriter from "typewriter-effect";

function FullStackTypewriter() {
  return (
    <Typewriter
      options={{
        strings: [
          "Team Player",
          "Full Stack Web Developer",
          "Problem Solver",
          "Lifelong Student",
        ],
        autoStart: true,
        loop: true,
        pauseFor: 1300,
        deleteSpeed: 40,
        delay: 120,
      }}
    />
  );
}

export default FullStackTypewriter;
